import HomeCanvas from './HomeCanvas';

export default HomeCanvas;
